import { useTranslation } from "react-i18next";
import {
  OTP_PREFERENCE_EMAIL,
  OTP_PREFERENCE_TOTP,
  OTP_PREFERENCE_LABELS,
  type OtpPreference,
} from "../../domain/constants/otpConstants";

interface OtpPreferenceSelectorProps {
  value: OtpPreference;
  onChange: (value: OtpPreference) => void;
  disabled?: boolean;
}

export const OtpPreferenceSelector = ({
  value,
  onChange,
  disabled = false,
}: OtpPreferenceSelectorProps) => {
  const { t } = useTranslation("auth");
  const options: OtpPreference[] = [OTP_PREFERENCE_TOTP, OTP_PREFERENCE_EMAIL];

  return (
    <div className="flex flex-col gap-3">
      {options.map((option) => {
        const selected = value === option;
        return (
          <button
            key={option}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option)}
            className={`rounded-xl border p-4 text-left transition-colors ${
              selected
                ? "border-primary bg-[#EAF2FF]"
                : "border-gray-200 bg-white hover:bg-gray-50"
            } disabled:cursor-not-allowed disabled:opacity-60`}
          >
            <p className="text-sm font-semibold text-gray-900">
              {option === OTP_PREFERENCE_TOTP
                ? t("otpPreferenceSelector.authenticatorApp")
                : t("otpPreferenceSelector.emailCode")}
            </p>
            <p className="mt-1 text-sm text-gray-500">
              {OTP_PREFERENCE_LABELS[option]}
            </p>
          </button>
        );
      })}
      <p className="text-xs text-gray-500">
        {t("otpPreferenceSelector.backupHint")}
      </p>
    </div>
  );
};
